var map = {
	"./YouView.svg": 52814,
	"./android.svg": 53884,
	"./apple-TV.svg": 36322,
	"./chrome-cast.svg": 91069,
	"./fireTV.svg": 67243,
	"./google-tv.svg": 80052,
	"./ipad.svg": 87114,
	"./iphone.svg": 82603,
	"./now-tv.svg": 81678,
	"./roku.svg": 32792,
	"./samsung.svg": 50740,
	"./sky.svg": 25174,
	"./virgin.svg": 54422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26371;